/** @format */

import { END_POINT } from "utils";
import { getRequest } from "./axios";
import {
  ServiceRevenueQuery,
  ServiceRevenueResponse,
  ServiceRevenueSummaryResponse,
  S2cQuery,
  S2dQuery,
  S2eQuery,
  S3Query,
  S4Query,
  S5Query,
  S6Query,
  S7Query,
  TResponse,
} from "types";

const buildQueryString = (params: ServiceRevenueQuery) => {
  const search = new URLSearchParams();
  if (params.from_date) search.append("from_date", params.from_date);
  if (params.to_date) search.append("to_date", params.to_date);
  if (Array.isArray(params.group_ids) && params.group_ids.length) {
    params.group_ids.forEach((id) => search.append("group_ids[]", String(id)));
  }
  const qs = search.toString();
  return qs ? `?${qs}` : "";
};

const buildBasicQueryString = (params: {
  from_date: string;
  to_date: string;
  [key: string]: any;
}) => {
  const search = new URLSearchParams();
  if (params.from_date) search.append("from_date", params.from_date);
  if (params.to_date) search.append("to_date", params.to_date);

  // Handle optional filters
  Object.keys(params).forEach((key) => {
    if (
      key !== "from_date" &&
      key !== "to_date" &&
      params[key] !== undefined &&
      params[key] !== null
    ) {
      if (Array.isArray(params[key]) && params[key].length > 0) {
        params[key].forEach((val: any) =>
          search.append(`${key}[]`, String(val)),
        );
      } else if (!Array.isArray(params[key])) {
        search.append(key, String(params[key]));
      }
    }
  });

  const qs = search.toString();
  return qs ? `?${qs}` : "";
};

export const reportService = {
  s1Hkd: async (
    params: ServiceRevenueQuery,
  ): Promise<ServiceRevenueResponse | null> => {
    try {
      const rs = await getRequest(
        `${END_POINT.REPORTS.S1_HKD}${buildQueryString(params)}`,
      );
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  s1HkdSummary: async (
    params: ServiceRevenueQuery,
  ): Promise<ServiceRevenueSummaryResponse | null> => {
    try {
      const rs = await getRequest(
        `${END_POINT.REPORTS.S1_HKD}/summary${buildQueryString(params)}`,
      );
      return rs.data;
    } catch (error) {
      return null;
    }
  },

  s2cHkd: async (params: S2cQuery): Promise<TResponse<any> | null> => {
    try {
      const rs = await getRequest(
        `${END_POINT.REPORTS.S2C_HKD}${buildBasicQueryString(params)}`,
      );
      return rs.data;
    } catch (error) {
      return null;
    }
  },

  s2dHkd: async (params: S2dQuery): Promise<TResponse<any> | null> => {
    try {
      const rs = await getRequest(
        `${END_POINT.REPORTS.S2D_HKD}${buildBasicQueryString(params)}`,
      );
      return rs.data;
    } catch (error) {
      return null;
    }
  },

  s2eHkd: async (params: S2eQuery): Promise<TResponse<any> | null> => {
    try {
      const rs = await getRequest(
        `${END_POINT.REPORTS.S2E_HKD}${buildBasicQueryString(params)}`,
      );
      return rs.data;
    } catch (error) {
      return null;
    }
  },

  s3Hkd: async (params: S3Query): Promise<TResponse<any> | null> => {
    try {
      const rs = await getRequest(
        `${END_POINT.REPORTS.S3_HKD}${buildBasicQueryString(params)}`,
      );
      return rs.data;
    } catch (error) {
      return null;
    }
  },

  s4Hkd: async (params: S4Query): Promise<TResponse<any> | null> => {
    try {
      const rs = await getRequest(
        `${END_POINT.REPORTS.S4_HKD}${buildBasicQueryString(params)}`,
      );
      return rs.data;
    } catch (error) {
      return null;
    }
  },

  s5Hkd: async (params: S5Query): Promise<TResponse<any> | null> => {
    try {
      const rs = await getRequest(
        `${END_POINT.REPORTS.S5_HKD}${buildBasicQueryString(params)}`,
      );
      return rs.data;
    } catch (error) {
      return null;
    }
  },

  s6Hkd: async (params: S6Query): Promise<TResponse<any> | null> => {
    try {
      const rs = await getRequest(
        `${END_POINT.REPORTS.S6_HKD}${buildBasicQueryString(params)}`,
      );
      return rs.data;
    } catch (error) {
      return null;
    }
  },

  s7Hkd: async (params: S7Query): Promise<TResponse<any> | null> => {
    try {
      const rs = await getRequest(
        `${END_POINT.REPORTS.S7_HKD}${buildBasicQueryString(params)}`,
      );
      return rs.data;
    } catch (error) {
      return null;
    }
  },
};
